import { useLazyQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import FileUpload from '../../components/Popups/FileUpload';
import './PodCast.scss';
import { useCallback, useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import ToasterWithMessage from '../../components/toaster';
import { useAppSelector } from '../../redux/app/hooks';
import QuestionBankList from '../../components/QuestionBankList/QuestionBankList';
import { 
    DELETE_IMAGES_PODCASTS, 
    DELETE_IMAGES_PODCASTS_ADMIN, 
    EDIT_IMAGE_OR_PODCAST, 
    UPDATE_IMAGES_PODCASTS, 
    UPDATE_IMAGES_PODCASTS_ADMIN, 
    UPLOAD_LIBRARY_IMAGE, 
    VIEW_ALL_LIBRARY_IMAGES 
} from '../ImageMaterial/api/ImageMaterialQuery';
import { debounce } from 'lodash';
import SingleAudioPlay from '../../components/SingleAudioPlay/SingleAudioPlay';
import { materialsData } from '../../utils/interface';
import { 
    FETCH_POLICY, 
    FETCH_POLICY_NO_CACHE, 
    MYLIBRARY_TEXTS, 
    PATH_ADDRESSES, 
    PODCAST_MATERIAL_TEXT, 
    SCHOOL_ADMIN, 
    STUDENT_ROLE, 
    SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, 
    SUBJECT_NOT_FOUND_ERROR, 
    TEACHER_ROLE 
} from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';
import { UPLOAD_PODCAST_ADMIN, VIEW_ALL_LIBRARY_PODCAST_ADMIN } from './api/PodCastQueries';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';

const PodCast = () => {
    const [podCastUrl, setPodCastUrl] = useState<string>();
    const [podcastCoverUrl,setPodcastCoverUrl] = useState<string>();
    const [podCastFilename, setPodCastFilename] = useState<string>();
    const [podcastDescription,setPodcastDescription] = useState<string>();
    const [podCastPdfFileData, setPodCastPdfFileData] = useState<materialsData | undefined>();
    const [podCastFileData, setPodCastFileData] = useState<File | null>();
    const [isPodCastUploadOpen, setIsPodCastUploadOpen] = useState<boolean>(false);
    const [podCastOpen, setPodCastOpen] = useState<boolean>(false);
    const [podCastOpenPdf, setPodCastOpenPdf] = useState(false);
    const [podCastData, setPodCastData] = useState<materialsData[]>();
    const [podCastUploadProgress, setPodCastUploadProgress] = useState(0);
    const [podCastUploadFailed, setPodCastUploadFailed] = useState<boolean>(false);
    const [podCastUploadFileName, setPodCastUploadFileName] = useState<string>('');
    const [podCastUploaded, setPodCastUploaded] = useState(false);
    const [podCastSearchValue, setPodCastSearchValue] = useState<string>('');
    const { success, error } = ToasterWithMessage();
    const { state:locationState } = useLocation();
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const navigate = useNavigate();
    const backNavigation = role === SCHOOL_ADMIN  ?  "/admin-materials-upload/materials/podcast" :(role === STUDENT_ROLE) ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PODCAST_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PODCAST_PATH;
    const [refetch, SetRefetch] = useState<boolean>(false);
    const [shared, setShared] = useState<string>();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const {uploadCloud} = images;
    const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );

    const [materialAction,setMaterialAction] = useState<string>('');
    const [isEditPodcast, setIsEditPodcast] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [editPodcastMaterial] = useMutation(EDIT_IMAGE_OR_PODCAST, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log("[Log] editPodcastMaterial", data);
           if(data?.editMylibraryImageOrPodcast) {
                setPodCastFileData(null);
                if(!(podCastFileData && podCastUrl)) {
                    success("File updated successfully!");
                }
                if(podCastFileData && podCastUrl) {
                    if (podCastFilename) {
                        setPodCastUploadFileName(podCastFilename);
                    }
                    setPodCastUploaded(true);
                    setPodCastUploadProgress(100);
                }
                setPodCastFilename('');
                setPodCastUrl('');
                setPodcastCoverUrl('');
                setPodcastDescription('');
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                SetRefetch(!refetch);
           }
        },
        onError: (err) => {
            error(err?.message);
            if (podCastFilename) {
                setPodCastUploadFileName(podCastFilename);
            }
            if(podCastFileData && podCastUrl) {
                setPodCastUploaded(true);
                setPodCastUploadProgress(0);
                setPodCastUploadFailed(true);
            }
        }
    });

    const [uploadPodcast] = useMutation(UPLOAD_LIBRARY_IMAGE, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMultipleMylibraryImagesAndPodcasts?.json) {
                setUploadedPayloads([]);
                const result = data?.uploadMultipleMylibraryImagesAndPodcasts?.json || {};
                setUploadResultsForTeacher(result);

                const hasFailures =
                result.failed_count > 0 ||
                result.results.some((item: any) => item.status === "error");

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setPodCastFileData(null);
                if (podCastFilename) {
                    setPodCastUploadFileName(podCastFilename);
                }
                setPodCastUploaded(true);
                setPodcastCoverUrl('');
                setPodcastDescription('');
                setPodCastUploadProgress(100);
                setPodCastFilename('');
                setPodCastUrl('');
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (podCastFilename) {
                setPodCastUploadFileName(podCastFilename);
            }
            setPodCastUploaded(true);
            setPodCastUploadProgress(0);
            setPodCastUploadFailed(true);
        }
    });

     const [uploadPodcastAdmin] = useMutation(UPLOAD_PODCAST_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMylibraryPodcastsBySchoolAdmin) {
                setUploadedPayloads([]);

                const result = data.uploadMylibraryPodcastsBySchoolAdmin?.result || [];

                setUploadResults(result);

                const hasFailures = result.some(
                    (res: UploadResult) => res.classrooms_failed.length > 0
                );

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }
                setPodCastFileData(null);
                if (podCastFilename) {
                    setPodCastUploadFileName(podCastFilename);
                }
                setPodCastUploaded(true);
                setPodcastCoverUrl('');
                setPodcastDescription('');
                setPodCastUploadProgress(100);
                setPodCastFilename('');
                setPodCastUrl('');
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (podCastFilename) {
                setPodCastUploadFileName(podCastFilename);
            }
            setPodCastUploaded(true);
            setPodCastUploadProgress(0);
            setPodCastUploadFailed(true);
        }
    });

    const [getAllPodcast, { loading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMylibraryImagesPodcastsInfo?.nodes) {
                setPodCastData(data?.getMylibraryImagesPodcastsInfo?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    }
                }, 2000);
            }
        }
    });

    const [getAllPodcastAdmin, { loading:AdminLoading }] = useLazyQuery(VIEW_ALL_LIBRARY_PODCAST_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMylibraryPodcastsForAdmin?.nodes) {
                setPodCastData(data?.getMylibraryPodcastsForAdmin?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(podCastData && podCastData.length > 0){
        podCastData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[podCastData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [updatePodcast] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success(`${shared} successfully`);
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    }
                }, 2000);
            }
        }
    })

    const [updatePodcastAdmin] = useMutation(UPDATE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success(`${shared} successfully`);
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    })

    const [deletePodcast] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
                    }
                }, 2000);
            }
        }
    })

     const [deletePodcastAdmin] = useMutation(DELETE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    })


    useEffect(() => {
        if (role === SCHOOL_ADMIN) {
          getAllPodcastAdmin({
            variables: {
              subjectId: selectedSubjectId,
              searchInput: `%${podCastSearchValue.trim()}%`,
              classroomIds: [selectedClassroomIdAdmin],
            },
          });
        } else {
          getAllPodcast({
            variables: {
              lId: selectedLibraryId,
              sjId: selectedSubjectId,
              cId: selectedClassRoomId,
              limit: null,
              offset: null,
              searchInput: `%${podCastSearchValue.trim()}%`,
              ...(role === STUDENT_ROLE && { isClassroom: true }),
            },
          });
        }
    }, [refetch]);

    useEffect(() => {
        if (materialAction === 'edit' && hasSubmittedForEdit) {
            console.log("edit podcast useEffect", podCastFileData, podCastFilename, podCastUrl, podcastCoverUrl, podcastDescription, hasSubmittedForEdit);
            let newFileName;
            let newFilePath;
            let newFileSize;
            let newCoverImagePath;
            let newFileDescription;

             if(podCastFilename !== podCastPdfFileData?.filename){
                newFileName = podCastFilename?.replace(/\.mp3$/, "")?.trim();
            }
            if(podCastUrl && podCastFileData) {
                newFilePath = podCastUrl;
                newFileSize = podCastFileData?.size;
            }
            if(podcastDescription !== podCastPdfFileData?.fileDescription){
                newFileDescription = podcastDescription?.trim();
            }
            if(podcastCoverUrl && podcastCoverUrl !== podCastPdfFileData?.coverImagePath) {
                newCoverImagePath = podcastCoverUrl;
            }
            console.log("new values after assignment", newFileName, newFilePath, newFileSize, newFileDescription, newCoverImagePath);
            editPodcastMaterial({
                variables: {
                    fileId: podCastPdfFileData?.fileId, 
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    fileType: MYLIBRARY_TEXTS?.PODCAST_TEXT,
                    ...(newFileDescription && { newFileDescription: newFileDescription }),
                    ...(newCoverImagePath && { newCoverImage: newCoverImagePath }),
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize })
                }
            });
        }
    }, [podCastFileData, podCastFilename, podCastUrl, podcastDescription, hasSubmittedForEdit]);

    const formatUploadedPayloads = (
        uploadedPayloads: UploadedFilePayload[],
        podcastCoverUrl: string | undefined,
        podcastDescription: string,
    ) => {
        const isSingle = uploadedPayloads.length === 1;
    
      return uploadedPayloads.map((item) => {
    
        return {
            filename: item.filename?.replace(/\.pdf$/, "")?.trim(),
            filepath: item.filepath,
            filesize: item.filesize,
            isClassroom: false,
            coverImagePath: podcastCoverUrl || null, 
            ...(isSingle
                ? { fileDescription: podcastDescription?.trim() }
                : { fileDescription: item?.fileDescription }
            ),
        };
        });
        };
    
        useEffect(() => {
            if(uploadedPayloads.length > 0 ){
                const updatedFormattedPayload = formatUploadedPayloads(
                    uploadedPayloads,
                    podcastCoverUrl,
                    podcastDescription || ''
                );
                if(role === SCHOOL_ADMIN){
                uploadPodcastAdmin({
                    variables: {
                    files: updatedFormattedPayload,
                    classroomIds: [selectedClassroomIdAdmin],
                    subjectId: selectedSubjectId,
                    },
                });
                } else if(role === TEACHER_ROLE) {
                uploadPodcast({
                    variables: {
                        libraryId: selectedLibraryId,
                        classroomId: selectedClassRoomId,
                        subjectId: selectedSubjectId,
                        files: updatedFormattedPayload
                    }
                })
                }
            }
        }, [ uploadedPayloads ]);

    //To open pdf in detailed view
    const handleOpenFile = (podcastData: materialsData) => {
        setPodCastOpenPdf(true);
        setPodCastPdfFileData(podcastData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setPodCastOpenPdf(false);
        setPodCastPdfFileData(undefined);
        if (role === SCHOOL_ADMIN) {
          getAllPodcastAdmin({
            variables: {
              subjectId: selectedSubjectId,
              searchInput: `%${podCastSearchValue.trim()}%`,
                            classroomIds: [selectedClassroomIdAdmin],

            },
          });
        } else {
        getAllPodcast({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: `%${podCastSearchValue.trim()}%`,
                ...(role === STUDENT_ROLE && { isClassroom: true })
            }
        });
    }
    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setPodCastSearchValue(value);
            if (role === SCHOOL_ADMIN) {
            getAllPodcastAdmin({
                variables: {
                subjectId: selectedSubjectId,
                searchInput: `%${value.trim()}%`,
                              classroomIds: [selectedClassroomIdAdmin],

                },
            });
        } else {
            getAllPodcast({
                variables:{
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId:selectedClassRoomId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    ...(role === STUDENT_ROLE && { isClassroom: true })
                }
            });
        }
        }, 500),
        [getAllPodcast]
    );
    
    //To done actions in podcast
    const handlePodcastActions = (data:materialsData,action:string) => {
        console.log("[Log] podcast action", action, data);
        if (action === "delete") {
            if(role === SCHOOL_ADMIN){
             deletePodcastAdmin({
                variables : {
                     input: {
                      pSubjectId: selectedSubjectId,
                      pFileId: data?.fileId,
                      pLType: MYLIBRARY_TEXTS?.PODCAST_TEXT,
                      pClassroomIds: [selectedClassroomIdAdmin],
                    },
                }
             })
            }else{
            deletePodcast({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            })
            }
        } else if (action === "edit") {
            console.log("edit podcast material", data);
            setMaterialAction('edit');
            setIsEditPodcast(true);
            setIsPodCastUploadOpen(true);
            setPodCastOpen(true);
            setPodCastPdfFileData(data);
        } else if (action === "share" || "unshare") {
            setShared(data?.isclassroom ? "Unshared" : "Shared");
            if(role === SCHOOL_ADMIN){
              updatePodcastAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: !data?.isclassroom,
                    pLType: MYLIBRARY_TEXTS?.PODCAST_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updatePodcast({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    isClassroom: !data?.isclassroom,
                    fId: data?.fileId
                }
            })
           }
        }
    }

    //To open upload popup in mobile screen
       const handleOpenUpload = () => {
        setIsPodCastUploadOpen(true);
        setPodCastOpen(true);
    };

    return (
        <div className={`PodCast ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={locationState?.imageSrc}
                backgroundColor={locationState?.backGroundColor}
                subject={locationState?.title}
                subCategory={MYLIBRARY_TEXTS?.PODCAST_TEXT}
                setIsUploadOpen={setIsPodCastUploadOpen}
                openPdf={podCastOpenPdf}
                onClose={handleClosePdf}
                setOpen={setPodCastOpen}
                backNavigation={{ path: backNavigation, state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={podCastSearchValue}
                setSearchValue={setPodCastSearchValue}
            />
            {
                podCastOpenPdf ?
                    <SingleAudioPlay podCastPdfFileData={podCastPdfFileData}/>
                    :
                    <>
                        {
                            loading  || AdminLoading? <Loader bottom='165px' />
                                :
                                <div className='PodCastBody'>
                                    <QuestionBankList
                                        type={MYLIBRARY_TEXTS?.PODCAST_TEXT}
                                        subject={locationState?.title}
                                        subCategory={MYLIBRARY_TEXTS?.PODCAST_TEXT}
                                        questionBankData={podCastData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handlePodcastActions}
                                        setRefetch={SetRefetch}
                                    />
                                </div>
                        }
                    </>
            }
            {isPodCastUploadOpen && !isEditPodcast && 
            <CommonBulkUpload 
                page={MYLIBRARY_TEXTS?.PODCAST_TEXT} 
                name = {PODCAST_MATERIAL_TEXT} 
                type='audio' 
                setUploadedPayloads = {setUploadedPayloads} 
                setFilesStatusData = {setFilesStatusData} 
                setTotalProgress = {setTotalProgress} 
                setSuccessCount = {setSuccessCount} 
                setFailureCount = {setFailureCount} 
                setPodcastDescription = {setPodcastDescription} 
                setCoverImageUrl ={setPodcastCoverUrl} 
                setUrl={setPodCastUrl} 
                open={podCastOpen} 
                setOpen={setPodCastOpen} 
                setIsUploadOpen={setIsPodCastUploadOpen} 
                folderName="materials" 
                setFilename={setPodCastFilename} 
                setFileData={setPodCastFileData} 
                setUploadFailed={setPodCastUploadFailed} 
                setUploadProgress={setPodCastUploadProgress} 
                setuploaded={setPodCastUploaded} 
                setUploadFileName={setPodCastUploadFileName} 
            />}
            {isPodCastUploadOpen && podCastPdfFileData && isEditPodcast && 
                <FileUpload 
                page={MYLIBRARY_TEXTS?.PODCAST_TEXT} 
                setHasSubmittedForEdit={setHasSubmittedForEdit} 
                setMaterialAction={setMaterialAction} 
                selectedFileData={podCastPdfFileData} 
                isEdit = {isEditPodcast} 
                setIsEdit = {setIsEditPodcast} 
                name = {PODCAST_MATERIAL_TEXT} 
                type='audio' 
                setPodcastDescription = {setPodcastDescription} 
                coverImageUrl={podcastCoverUrl} 
                setCoverImageUrl ={setPodcastCoverUrl} 
                setUrl={setPodCastUrl} 
                open={podCastOpen} 
                setOpen={setPodCastOpen} 
                setIsUploadOpen={setIsPodCastUploadOpen} 
                folderName="materials" 
                setFilename={setPodCastFilename} 
                setFileData={setPodCastFileData} 
                setUploadFailed={setPodCastUploadFailed} 
                setUploadProgress={setPodCastUploadProgress} 
                setuploaded={setPodCastUploaded} 
                setUploadFileName={setPodCastUploadFileName} 
                />
            }
            {podCastUploaded && 
                <UploadToaster 
                    successCount = {successCount} 
                    failureCount={failureCount} 
                    FilesStatusData = {FilesStatusData} 
                    setFilesStatusData = {setFilesStatusData} 
                    totalProgress = {totalProgress} 
                    setTotalProgress = {setTotalProgress} 
                    uploaded={podCastUploaded} 
                    setuploaded={setPodCastUploaded} 
                    uploadProgress={podCastUploadProgress} 
                    setUploadProgress={setPodCastUploadProgress} 
                    fileName={podCastUploadFileName} 
                    setUploadFileName={setPodCastUploadFileName} 
                    uploadFailed={podCastUploadFailed} 
                    setUploadFailed={setPodCastUploadFailed} 
                />
            }
            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='PodcastDirectClass'
            />
            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !podCastOpenPdf &&
            <div className='libraryHeaderUploadContainer'> 
            <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
             <img src={uploadCloud} alt="upload" className='uploadImage' />
            </div>
            </div>}
        </div>
    )
}

export default PodCast;
